import {
    ua,
    debug,
    getDeepVal,
    getRemoveNullObject,
    miniNav,
    jump_middle_page,
} from '@kkmh/utils'
import {
    getH5Rechargedetail,
    getH5RechargegoodsBrowser,
    getH5Memberdetail,
    getUserMe,
} from "../../../assets/api";
import {
    getPayParam,
    getNativeInfo,
    getPayInfo,
    jumpToLogin,
} from "../../../assets/utils";
import {h5_directpay} from '@kk/h5-sdk'

export const getBaseParam = (opt = {}) => {
    return new Promise(resolve => {
        getNativeInfo().then((nativeinfo) => {
            resolve({
                ...getPayParam(opt),
                ...nativeinfo,
            })
        });
    })
}
export const checkParamPassed = (opt = {}) => {
    return new Promise(resolve => {
        (async () => {
            if (opt.good_type !==1 && opt.good_type !==2) {
                resolve({code:-11001,message:'good_type不正确'+opt.good_type});
                return null;
            }
            if (!opt.good_id) {
                resolve({code:-11002,message:'good_id不正确'});
                return null;
            }
            let res = await getUserMe();
            let nickname = getDeepVal(res,'data.user.nickname','');
            if (!nickname) {
                if (ua['iphone'] && ua['kkmh']) {
                    // 不做验证登录，游客模式可支付
                } else {
                    let islogin = await jumpToLogin();
                    if (islogin) {
                        res = await getUserMe();
                        resolve({code:200,data:res.data,message:'ok'});
                        return null;
                    } else {
                        resolve({code:401,message:'未登录'});
                        return null;
                    }
                }
            }
            resolve({code:200,data:res.data,message:'ok'});
        })()
    })
}
export const jumpMiniDirectPage = (opt = {}) => {
    let V_PARAM = {
        ...opt,
        pay_source : 2,//2.小程序埋点-活动页(h5)
    }
    let url = '/pages/directpay/directpay?v_param='+encodeURIComponent(JSON.stringify(V_PARAM))+'&t='+new Date().getTime();
    miniNav(url);
}
export const jumpBrowserDirectPage = (opt = {}, pay_type, request_id) => {
    let V_PARAM = {
        ...opt,
        pay_type,
        request_id,
    }
    jump_middle_page(V_PARAM);
}
export const jumpNativeDirectPage = (opt = {}, cb) => {
    let pay_info = JSON.stringify(getPayInfo(opt));
    let trigger_page = (opt.trigger_page !== '会员半屏弹窗页' && opt.trigger_page !== 'KK币半屏弹窗页') ? '直接支付' : opt.trigger_page;
    let param = {
        pay_info    : pay_info,
        track_info  : {
            TriggerPage : opt.origin,
            CurPage     : opt.trigger_page,
            NoticeType  : opt.notice_type,
            SendComic   : opt.send_comic,
            FreePayRate : opt.free_pay_rate,
        },
        good_id     : opt.good_id,
        good_type   : opt.good_type == 1 ? 0 : 1, //0-kkb 1-vip
        from_page   : trigger_page ,//会员半屏弹窗页, KK币半屏弹窗页, 直接支付
        pay_source  : 2, //活动页
    }
    debug(param)
    h5_directpay({
        param,
        callback : (res, nativecallback_name) => {
            cb && cb(res, nativecallback_name);
        }
    },585000);
    
}
export const getDetailData = (opt) => {
    return new Promise(resolve => {
        if (opt.good_type == 1) {// kkb
            // 不支持端外调用
            getH5Rechargedetail(opt).then((res) => {
                resolve(res);
            }).catch(error => {
                resolve(error);
            })
        } else {
            getH5Memberdetail(opt).then((res) => {
                resolve(res);
            }).catch(error => {
                resolve(error);
            })
        }
    })
}
export const getViewData = (opt) => {
    return new Promise(resolve => {
        if (opt.good_type == 1) {// kkb
            // getH5Rechargedetail接口当时不支持端外调用
            getH5RechargegoodsBrowser(opt).then((res) => {
                let {code, message, data={}} = res || {};
                if (code !== 200) {
                    resolve({code:-12011,message});
                    return null;
                }
                let viewdata = getKkbViewData(opt, data);
                if (viewdata.error_msg) {
                    resolve({code:-12012,data:viewdata,message:viewdata.error_msg});
                    return null;
                }
                resolve({code:200,data:viewdata,message:'ok'});
            }).catch(error => {
                resolve({code:-12013,data:{},message:error});
            })
        } else {
            getH5Memberdetail(opt).then((res) => {
                let {code, message, data={}} = res || {};
                if (code !== 200) {
                    resolve({code:-12021,message});
                    return null;
                }
                let viewdata = getVipViewData(opt, data);
                if (viewdata.error_msg) {
                    resolve({code:-12022,data:viewdata,message:viewdata.error_msg});
                    return null;
                }
                resolve({code:200,data:viewdata,message:'ok'});
            }).catch(error => {
                resolve({code:-12023,data:{},message:error});
            })
        }
    })
}
const getKkbViewData = (opt, data) => {
    let viewdata    = {};
    let goods       = getDeepVal(data,'recharges.0.recharge_goods',[]);
    let paytypes    = getDeepVal(data,'recharges.0.pay_types',[]);
    let good        = {};
    let error_msg   = '';
    goods.forEach((item, index) => {
        if (item.id == opt.good_id) {
            good = item;
        }
    })
    if (!good.id) {
        error_msg = '商品不存在';
    }

    let vtypes = {
        'weixin'    : [10],
        'alipay'    : [9],
        'qqnative'  : [12],
        'qqbrowser' : [9, 11, 14, 21],
        'browser'   : [9, 11, 21],
    }
    let ary = getPayPlats(vtypes, paytypes);
    viewdata = {
        paytypes   : ary,
        request_id : '',
        good_title : good.title || '',
        good_price : good.real_price || 0,
        error_msg  : error_msg,
    }
    return viewdata;
}

const getVipViewData = (opt, data) => {
    let viewdata    = {};
    let coupon_id   = opt.coupon_id;
    let paytypes    = data.pay_types;
    let good        = data.member_good;
    let request_id  = data.request_id || '';
    let title       = good.title;
    let price       = getDeepVal(good,'price.real_price',0);
    let error_msg   = '';
    if (coupon_id !== '') {
        let usable_list         = getDeepVal(good,'coupon.usable_list',[]);
        let unreachable_list    = getDeepVal(good,'coupon.unreachable_list',[]);
        
        usable_list.forEach((v) => {
            if(v.id == coupon_id) {
                price = price - v.amount;
            }
        })
        unreachable_list.forEach((v) => {
            if(v.id == coupon_id) {
                if (v.locked) { 
                    error_msg = '优惠券已过期!';
                } else {
                    error_msg = '优惠券已锁住5分钟后解锁';
                }
            }
        })
    }

    let vtypes = {
        'weixin'    : [10],
        'alipay'    : [9],
        'qqnative'  : [12],
        'qqbrowser' : [9, 11, 14],
        'browser'   : [9, 11],
    };
    let ary = getPayPlats(vtypes, paytypes);
    viewdata = {
        paytypes   : ary,
        request_id : request_id,
        good_title : title,
        good_price : price,
        error_msg  : error_msg,
    }
    return viewdata;
}

const getPayPlats = (vtypes, paytypes) => {
    /* 设置支付方式
        9    支付宝－支付宝h5
        10   微信支付－微信公众号 - 需使用oauth2 url方式打开 使用微信sdk
        11   微信支付－微信h5   - 直接调用微信支付url
        12   QQ支付－腾讯公众号 - qq客户端里可用qqsdk , jsapi实现QQ支付
        14   QQ支付－腾讯h5    - 呼起shceme的方式掉用QQ支付-其实是腾讯的url地址与支付宝一样
        21   京东支付
    */
    let current_ua  = ua.weixin ? 'weixin' : ua.alipay ? 'alipay' : ua.qqnative ? 'qqnative' :  ua.qq ? 'qqbrowser': 'browser';
    let types       = vtypes[current_ua];
    let ary         = [];
    paytypes.forEach(function(item){
        types.forEach(function(sitem){
            if (item.pay_type == sitem) {
                ary.push(item);
            }  
        })
    })
    return ary;
}


// WEBPACK FOOTER //
// ./node_modules/@kkmh/pays/src/components/cashdesk/js/common.js